import { Box, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2AnnouncementDto } from "../../../autogen/bff-api";
import { TipTap } from "../../input/TipTap/TipTap";
import { formatDateTime, personName } from "./communicationUtils";

export const AnnouncementCard = ({ announcement }: { announcement: SeV2AnnouncementDto }) => {
  const { t } = useTranslation();
  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" bg="smBackground" p="4">
      <Text fontWeight="semibold" color="smText">
        {announcement.title}
      </Text>
      {announcement.question ? (
        <Stack mt="3" spacing="3">
          <Box>
            <Text fontSize="xs" fontWeight="semibold" color="smMuted" mb="1">
              {t("Question")}
            </Text>
            <TipTap content={announcement.question} editable={false} maxHeight="96" />
          </Box>
          <Box>
            <Text fontSize="xs" fontWeight="semibold" color="smPrimary" mb="1">
              {t("Answer")}
            </Text>
            <TipTap content={announcement.content} editable={false} maxHeight="96" />
          </Box>
        </Stack>
      ) : (
        <Box mt="2">
          <TipTap content={announcement.content} editable={false} maxHeight="96" />
        </Box>
      )}
      <Text mt="3" fontSize="xs" color="smMuted">
        {personName(announcement.createdBy)} · {formatDateTime(announcement.createdAt)}
      </Text>
    </Box>
  );
};
